import { Row, Col, Card, Container } from 'react-bootstrap'
import Contact from '../Contact/Contact'
import Footer from '../footer/footer'
import './project.css'

const Project = () => {
  return (
    <>
        <div className="project p-5">
            <Container>
            <Row className='p-3'>
                <Col>
                    <h3 className='under main-color text-center'>Project</h3>
                </Col>
            </Row>
            <Row className='align-items-center justify-content-center text-center pt-5 gap-5'>
                <Col sm={6} lg={4}>
                    <img src="1.png" alt="" className='rounded' />
                    <h3 className='pt-3 main-color fw-bold'>Admin DashBoard</h3>
                    <a className='fw-bolder' href='http://admin-dashboard03.netlify.app/ ' >Check it out</a>
                    <div className="language p-3">
                        <div className="lan-content me-3 text-center">
                            <h3 className='lead fw-bold'>React Js</h3>
                        </div>
                        <div className="lan-content">
                            <h3 className='lead fw-bold'>Sass</h3>
                        </div>
                    </div>
                </Col>
                <Col sm={6} lg={4}>        
                    <img src="5.png" alt="" className='rounded'/>
                    <h3 className='pt-3 main-color fw-bold'>Fund of Web IT</h3>
                    <a className='fw-bolder' href='https://fund-of-web.netlify.app/ ' >Check it out</a>
                    <div className="language p-3">
                        <div className="lan-content me-3 text-center">
                            <h3 className='lead fw-bold'>React Js</h3>
                        </div>
                        <div className="lan-content">
                            <h3 className='lead fw-bold'>CSS</h3>
                        </div>
                    </div>
                </Col>
                <Col sm={6} lg={4}>   
                    <img src="2.png" alt="" className='rounded' />
                    <h3 className='pt-3 main-color fw-bold'>E-Commerce Website</h3>
                    <a className='fw-bolder' href='https://e-commerce0.netlify.app/' >Check it out</a>
                    <div className="language p-3">
                        <div className="lan-content me-3 text-center">
                            <h3 className='lead fw-bold'>HTML</h3>
                        </div>
                        <div className="lan-content">
                            <h3 className='lead fw-bold'>CSS</h3>
                        </div>
                    </div>
                </Col>
                <Col sm={6} lg={4}>
                    <img src="3.png" alt="" className='rounded' />
                    <h3 className='pt-3 main-color fw-bold'>Chipper Gym</h3>
                    <a className='fw-bolder' href='https://chippers-gym.netlify.app/' >Check it out</a>
                    <div className="language p-3">
                        <div className="lan-content me-1">
                            <h3 className='lead fw-bold'>HTML/CSS</h3>
                        </div>
                        <div className="lan-content me-1">
                            <h3 className='lead fw-bold'>JS</h3>
                        </div>
                        <div className="lan-content">
                            <h3 className='lead fw-bold'>BOOTSTRAP</h3>
                        </div>
                    </div>
                </Col>
                <Col sm={6} lg={4}>   
                    <img src="4.png" alt="" className='rounded' />
                    <h3 className='pt-3 main-color fw-bold'>YT-Project</h3>
                    <a className='fw-bolder' href='https://yt-project0.netlify.app/' >Check it out</a>
                    <div className="language p-3">
                        <div className="lan-content me-3 text-center">
                            <h3 className='lead fw-bold'>HTML/CSS</h3>
                        </div>
                        <div className="lan-content">
                            <h3 className='lead fw-bold'>BOOTSTRAP</h3>
                        </div>
                    </div>
                </Col>
            </Row>
            </Container>

            
            
            

            <div>
                <Contact/>
                <Footer/>
            </div>
            
        </div>
        
    </>
  )
}

export default Project

